import { Images, QuestionGroup, ScenarioStep, Steps } from '../state/interfaces'
import { emailAddress, thanks } from './common-steps'
import { bigEnterprise } from './mobile-steps'

export const bigEnterpriseGovernment: ScenarioStep = {
  ...bigEnterprise,
  next: Steps.THANKS,
}

export const thanksGovernment: ScenarioStep = {
  ...thanks,
  question: 'thanks-government_question',
  tip: 'thanks-government_tip',
  answers: [
    {
      id: 'continue',
      text: 'common_continue',
    },
  ],
}

export const emailAddressGovernment: ScenarioStep = {
  ...emailAddress,
  group: QuestionGroup.DEFAULT,
  next: Steps.BIG_ENTREPRISE,
  metadata: { grandImage: Images.ALERT_2 },
}
